/**
 * PostHog WOM (Word of Mouth) event tracking – Mantitude 10 March
 * Token: posthog-wom-events project.
 * Uses capture-phase + composedPath() so clicks inside Shadow DOM (WOM widgets) are tracked.
 * Events: login, add_to_cart, buy_now, product review tab, brand reviews, images clicked, instagram section.
 */
(function () {
  function capture(eventName, properties) {
    try {
      if (typeof window.posthog === 'undefined' || typeof window.posthog.capture !== 'function') return;
      window.posthog.capture(eventName, properties || {});
    } catch (e) {
}
  }

  function getText(el) {
    if (!el) return '';
    return (el.textContent || '').trim();
  }

  /** Get text from element and ancestors (for buttons with inner spans/SVG) */
  function getTextUp(el, maxDepth) {
    var depth = (maxDepth === undefined) ? 5 : maxDepth;
    var node = el;
    while (node && depth-- > 0) {
      var t = getText(node);
      if (t && t.length > 2) return t;
      node = node.parentElement || node.parentNode;
    }
    return getText(el);
  }

  /** Collect text from entire path (so we catch "Write a Review" etc. even if click is on icon) */
  function getPathText(path, maxLen) {
    var out = '';
    var len = (maxLen === undefined) ? 500 : maxLen;
    for (var i = 0; i < path.length && out.length < len; i++) {
      var node = path[i];
      if (node && node.nodeType === 1) {
        var t = getText(node);
        if (t && t.length < 200) out += ' ' + t;
      }
    }
    return out.trim();
  }

  /** Check if click is inside a WOM widget (composedPath crosses shadow boundaries) */
  function getWomWidgetFromPath(path) {
    if (!path || !path.length) return null;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.getAttribute) {
        var w = node.getAttribute('data-wom-widget');
        if (w === 'reviews' || w === 'social-proof') return w;
      }
    }
    return null;
  }

  /** True if click is inside reviews widget: Shadow DOM data attrs OR Liquid theme ids */
  function isInsideReviewsWidget(path) {
    if (getWomWidgetFromPath(path) === 'reviews') return true;
    if (pathHas(path, 'data-wom-rating-breakdown-container') ||
        pathHas(path, 'data-wom-reviews-list-container') ||
        pathHas(path, 'data-wom-reviews-layout') ||
        pathHas(path, 'data-wom-component', 'reviews')) return true;
    return pathHas(path, 'id', 'reviews-pagination') ||
           pathHas(path, 'id', 'review-filters') ||
           pathHas(path, 'id', 'reviews-list');
  }

  /** Find in path: element with attribute. If value is undefined, any presence counts. */
  function pathHas(path, attr, value) {
    if (!path || !path.length) return false;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || !node.getAttribute) continue;
      var v = node.getAttribute(attr);
      if (value === undefined || value === '') { if (v !== null && v !== undefined) return true; }
      else if (v === value) return true;
    }
    return false;
  }

  /** True if any node in path has class or className containing the given string (for Shadow DOM). */
  function pathHasClass(path, classNameSubstr) {
    if (!path || !path.length || !classNameSubstr) return false;
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node) continue;
      var cn = (node.className && typeof node.className === 'string' ? node.className : (node.getAttribute && node.getAttribute('class')) || '');
      if (cn.indexOf(classNameSubstr) !== -1) return true;
    }
    return false;
  }

  function isInsideImageGallery(path) {
    return pathHas(path, 'data-wom-image-gallery') || pathHasClass(path, 'wom-image-gallery');
  }

  // ---- WOM section timing: compute time in frontend, send to PostHog when user leaves ----
  // (PostHog does not calculate time; we must send time_ms / time_seconds as event properties.)
  var womSectionTimers = {
    reviews: { lastStart: null },
    social_proof: { lastStart: null },
    product_reviews: { lastStart: null },
    brand_reviews: { lastStart: null },
    instagram_home: { lastStart: null },
    instagram_pdp: { lastStart: null },
    instagram_reviews: { lastStart: null }
  };

  function getWomPageType() {
    if (typeof window === 'undefined' || !window.location || !window.location.pathname) return 'other';
    var path = window.location.pathname;
    if (path === '/' || path === '') return 'home';
    if (path.indexOf('/collections') === 0) return 'collection';
    if (path.indexOf('/products') === 0) return 'pdp';
    return 'other';
  }

  function startWomSectionTimer(key) {
    var t = womSectionTimers[key];
    if (!t) return;
    if (t.lastStart !== null) return; // already running
    t.lastStart = Date.now();
  }

  /** When user leaves section: end timer, compute duration, send event to PostHog (if >= 0.5s). */
  function stopWomSectionTimerAndCapture(key) {
    var t = womSectionTimers[key];
    if (!t || t.lastStart === null) return;
    var endTime = Date.now();
    var timeMs = Math.max(0, endTime - t.lastStart);
    t.lastStart = null;
    if (timeMs < 500) return; // ignore very short views
    var pageType = getWomPageType();
    var url = (typeof window !== 'undefined' && window.location && window.location.href) || '';
    capture('wom_section_time_' + key, {
      section: key,
      page_type: pageType,
      url: url,
      time_ms: timeMs,
      time_seconds: Math.round(timeMs / 1000)
    });
  }

  /** Flush any still-running timer (e.g. user closed tab while section was visible). */
  function flushWomSectionTimers() {
    for (var key in womSectionTimers) {
      if (!Object.prototype.hasOwnProperty.call(womSectionTimers, key)) continue;
      stopWomSectionTimerAndCapture(key);
    }
  }

  function stopWomSectionTimer(key) {
    stopWomSectionTimerAndCapture(key);
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', flushWomSectionTimers);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushWomSectionTimers();
    });

    if ('IntersectionObserver' in window) {
      try {
        // Enter: threshold 0.5 = section "in view". Leave: threshold 0.1 so we fire when they scroll away.
        var womObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var el = entry.target;
            var key = null;
            var widgetType = el.getAttribute && (el.getAttribute('data-wom-widget') || '');
            var compType = el.getAttribute && (el.getAttribute('data-wom-component') || '');
            if (widgetType === 'reviews' || compType === 'reviews' || (el.classList && el.classList.contains('wom-reviews-section'))) {
              key = 'reviews';
            } else if (widgetType === 'social-proof' || compType === 'social-proof' || (el.classList && el.classList.contains('wom-social-proof-banner'))) {
              key = 'social_proof';
            } else if (el.classList && el.classList.contains('wom-instagram-profile-section')) {
              var inReviews = el.closest && (el.closest('[data-wom-component="reviews"]') || el.closest('.wom-reviews-section'));
              key = inReviews ? 'instagram_reviews' : 'instagram_home';
            } else if (el.classList && el.classList.contains('manti-instagram-testimonials')) {
              var pageType = getWomPageType();
              key = pageType === 'home' ? 'instagram_home' : (pageType === 'pdp' ? 'instagram_pdp' : null);
            }
            if (!key) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              startWomSectionTimer(key);
            } else if (entry.intersectionRatio < 0.1) {
              // User left section: end timer and send event now (like ChatGPT example).
              stopWomSectionTimerAndCapture(key);
            }
          });
        }, { threshold: [0.1, 0.5] });

        window.addEventListener('DOMContentLoaded', function () {
          var selectors = [
            '[data-wom-component="reviews"]',
            '[data-wom-widget="reviews"]',
            '.wom-reviews-section',
            '[data-wom-widget="social-proof"]',
            '[data-wom-component="social-proof"]',
            '.wom-social-proof-banner',
            '.wom-instagram-profile-section',
            '.manti-instagram-testimonials'
          ];
          selectors.forEach(function (sel) {
            var nodes = document.querySelectorAll(sel);
            if (!nodes || !nodes.length) return;
            for (var i = 0; i < nodes.length; i++) {
              womObserver.observe(nodes[i]);
            }
          });
        });
      } catch (e) {
        // ignore observer errors
      }
    }
  }

  /** WOM filter: select by class/id (wom-filter-select, main-filter, filter-select) or options like All Reviews. */
  function isWomFilterSelect(select) {
    if (!select || select.tagName !== 'SELECT') return false;
    if (select.className && typeof select.className === 'string') {
      if (select.className.indexOf('wom-filter-select') !== -1 || select.className.indexOf('filter-select') !== -1) return true;
    }
    if (select.id === 'review-filter-below-images' || select.id === 'main-filter') return true;
    if (!select.options || select.options.length < 2) return false;
    var hasAll = false, hasStar = false;
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var v = (opt.value || '').toLowerCase();
      var t = (opt.textContent || opt.text || '').toLowerCase();
      if (v === 'all' || t.indexOf('all review') !== -1) hasAll = true;
      if (v.indexOf('star') !== -1 || t.indexOf('star') !== -1 || v === 'highest' || v === 'lowest' || v === 'verified') hasStar = true;
    }
    return hasAll && hasStar;
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || target.tagName !== 'SELECT') return;
    if (!isWomFilterSelect(target)) return;
    var val = target.value || 'all';
    capture('wom_filter_changed', { filterValue: val });
  }, true);

  document.addEventListener('click', function (e) {
    var target = e.target;
    var path = (e.composedPath && e.composedPath()) || [];
    var widget = getWomWidgetFromPath(path);
    var pathText = getPathText(path);

    var clickEl = target && target.nodeType === 1 ? target : (target && (target.parentElement || target.parentNode));
    if (!clickEl || clickEl.nodeType !== 1) clickEl = target;
    var btn = clickEl.closest && (clickEl.closest('button') || clickEl.closest('a') || clickEl.closest('[role="button"]'));
    var label = (target.getAttribute && target.getAttribute('aria-label')) || '';
    if (btn) label = label || (btn.getAttribute && btn.getAttribute('aria-label')) || '';
    var text = getTextUp(btn || target);
    if (!text) text = getText(target);
    var combinedText = (text + ' ' + pathText).toLowerCase();

    // ---- Prev/Next image in modal ----
    if (label === 'Previous image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Previous image')) {
      capture('wom_review_image_prev_clicked', {});
      return;
    }
    if (label === 'Next image' || (btn && btn.getAttribute && btn.getAttribute('aria-label') === 'Next image')) {
      capture('wom_review_image_next_clicked', {});
      return;
    }

    // ---- Header login / account click ----
    var accountLink = clickEl && clickEl.closest && clickEl.closest('a');
    if (accountLink && accountLink.getAttribute('href') && (accountLink.getAttribute('href') || '').indexOf('/account') !== -1) {
      var inHeaderAccount = accountLink.closest && (accountLink.closest('.header__account-link') || accountLink.closest('header') || accountLink.closest('header-sidebar') || accountLink.closest('#sidebar-menu'));
      if (inHeaderAccount) {
        var isLogin = (accountLink.getAttribute('href') || '').indexOf('/account/login') !== -1;
        capture('login_clicked', { source: 'header', isLogin: isLogin });
        return;
      }
    }

    // ---- Instagram section clicked ----
    // Theme uses .manti-instagram-testimonials (home/PDP); WOM widget uses .wom-instagram-profile-section (reviews tab)
    var instaSection = clickEl && clickEl.closest && (clickEl.closest('.manti-instagram-testimonials') || clickEl.closest('.wom-instagram-profile-section'));
    if (instaSection) {
      var instaInReviews = clickEl.closest('[data-wom-component="reviews"]') || clickEl.closest('.wom-reviews-section');
      if (instaInReviews) {
        capture('wom_instagram_reviews_clicked', {});
      } else {
        var pageType = getWomPageType();
        if (pageType === 'home') {
          capture('wom_instagram_home_clicked', {});
        } else if (pageType === 'pdp') {
          capture('wom_instagram_pdp_clicked', {});
        } else {
          capture('wom_instagram_section_clicked', { page_type: pageType });
        }
      }
      return;
    }

    // ---- WOM Social proof clicked (before product card so PDP social proof is always counted) ----
    if (widget === 'social-proof' ||
        pathHas(path, 'data-wom-component', 'social-proof') ||
        pathHas(path, 'data-wom-sp-inner') ||
        pathHasClass(path, 'wom-social-proof') ||
        pathHasClass(path, 'wom-sp-container') ||
        pathHasClass(path, 'wom-social-proof-banner')) {
      capture('wom_social_proof_clicked', {});
      return;
    }

    // ---- Product / Brand review tabs (data-wom-review-tab from WOM JSX) ----
    var tabButton = clickEl && clickEl.closest && clickEl.closest('[data-wom-review-tab]');
    if (tabButton && tabButton.getAttribute) {
      var tab = tabButton.getAttribute('data-wom-review-tab') || '';
      if (tab === 'product') {
        capture('wom_product_reviews_tab_clicked', {});
        startWomSectionTimer('product_reviews');
        stopWomSectionTimer('brand_reviews');
        return;
      }
      if (tab === 'brand') {
        capture('wom_brand_reviews_tab_clicked', {});
        startWomSectionTimer('brand_reviews');
        stopWomSectionTimer('product_reviews');
        return;
      }
    }

    // ---- Cancel purchase: cart drawer close or continue shopping ----
    function pathContainsCartDrawer(path) {
      if (!path || !path.length) return false;
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (!n) continue;
        if (n.id === 'cart-drawer') return true;
        if (n.tagName && n.tagName.toLowerCase() === 'cart-drawer') return true;
        if (n.className && typeof n.className === 'string' && n.className.indexOf('cart-drawer') !== -1) return true;
      }
      return false;
    }
    var inCartDrawer = pathContainsCartDrawer(path);
    if (inCartDrawer) {
      var isClose = label === 'Close' || (label && label.toLowerCase().indexOf('close') !== -1) ||
        (clickEl && clickEl.closest && clickEl.closest('dialog-close-button')) ||
        (target.closest && target.closest('dialog-close-button'));
      var isContinueShopping = /continue\s*shopping/i.test(text) || /continue\s*shopping/i.test(pathText);
      if (isClose || isContinueShopping) {
        capture('cancel_purchase_clicked', { source: isClose ? 'cart_drawer_close' : 'continue_shopping' });
        return;
      }
    }
    if (typeof window !== 'undefined' && window.location && (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') !== -1)) {
      if (/continue\s*shopping/i.test(text) || /continue\s*shopping/i.test(pathText)) {
        capture('cancel_purchase_clicked', { source: 'cart_page_continue_shopping' });
        return;
      }
    }

    /** Get product context from form or page (for add to cart / buy now). */
    function getProductContextFromForm(form) {
      var ctx = { productHandle: '', variantId: '' };
      if (!form) return ctx;
      var idInput = form.querySelector && form.querySelector('input[name="id"]');
      if (idInput && idInput.value) ctx.variantId = String(idInput.value);
      var picker = form.querySelector && form.querySelector('variant-picker[handle]');
      if (picker && picker.getAttribute('handle')) ctx.productHandle = picker.getAttribute('handle');
      if (!ctx.productHandle && typeof window.location !== 'undefined' && window.location.pathname) {
        var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
        if (m) ctx.productHandle = m[1];
      }
      if (!ctx.productHandle && form.closest) {
        var card = form.closest('.product-card') || form.closest('product-card');
        if (card && card.getAttribute && card.getAttribute('handle')) ctx.productHandle = card.getAttribute('handle');
      }
      return ctx;
    }

    // ---- Buy now / dynamic checkout (Shopify payment button) ----
    var inPaymentButton = path.some(function (node) {
      return node && node.classList && node.classList.contains && (node.classList.contains('shopify-payment-button') || node.classList.contains('shopify-payment-button__button'));
    });
    if (inPaymentButton) {
      var payForm = (target.closest && target.closest('form')) || (btn && btn.closest && btn.closest('form'));
      var payCtx = getProductContextFromForm(payForm);
      capture('buy_now_clicked', { productHandle: payCtx.productHandle, variantId: payCtx.variantId });
      return;
    }

    // ---- Add to cart (submit button, not inside payment button) ----
    var submitEl = clickEl && clickEl.closest && (clickEl.closest('button[type="submit"]') || clickEl.closest('input[type="submit"]'));
    if (submitEl && submitEl.form) {
      var form = submitEl.form;
      var action = (form.action || form.getAttribute('action') || '').toLowerCase();
      var isCartAdd = action.indexOf('cart/add') !== -1 || action.indexOf('/cart/add') !== -1;
      var insidePay = form.querySelector && form.querySelector('.shopify-payment-button') && (form.querySelector('.shopify-payment-button').contains(target) || form.querySelector('.shopify-payment-button').contains(submitEl));
      if (!insidePay && isCartAdd) {
        var atcCtx = getProductContextFromForm(form);
        capture('add_to_cart_clicked', { productHandle: atcCtx.productHandle, variantId: atcCtx.variantId });
        return;
      }
    }

    // ---- Product card with WOM collection ratings (main DOM only) ----
    var card = target.closest && (target.closest('.product-card') || target.closest('product-card') || target.closest('.t4s-col-item') || target.closest('[data-product-handle]'));
    if (!card && target.closest) {
      var productLink = target.closest('a');
      if (productLink && productLink.getAttribute && (productLink.getAttribute('href') || '').indexOf('/products/') !== -1) card = productLink;
    }
    if (card) {
      var ratingEl = card.querySelector && card.querySelector('.wom-collection-rating');
      var hasWomInCard = ratingEl && (ratingEl.style.display === 'flex' || (window.getComputedStyle && window.getComputedStyle(ratingEl).display === 'flex'));
      if (hasWomInCard) {
        var handle = (ratingEl && ratingEl.getAttribute && ratingEl.getAttribute('data-product-handle')) ||
                    (card.getAttribute && card.getAttribute('handle')) || (card.getAttribute && card.getAttribute('data-product-handle')) || '';
        var title = (ratingEl && ratingEl.getAttribute && ratingEl.getAttribute('data-product-title')) ||
                    (card.querySelector && getText(card.querySelector('.product-title'))) || '';
        if (!handle && card.getAttribute && card.getAttribute('href')) {
          var hm = (card.getAttribute('href') || '').match(/\/products\/([^\/\?]+)/);
          if (hm) handle = hm[1];
        }
        capture('wom_product_card_clicked', { productHandle: handle, productTitle: title });
        return;
      }
      // Card with no WOM rating: no event (no_wom_product_card_clicked removed)
    }

    // ---- From here: only consider clicks inside reviews widget ----
    if (!isInsideReviewsWidget(path)) return;

    // ---- Instagram inside reviews (must run before Brand reviews fallback) ----
    // WOM tabs are in Shadow DOM: "Product Reviews" | "Brand Reviews" | "Instagram". Detect Instagram by path (composedPath includes shadow nodes).
    function pathHasIdContaining(path, substr) {
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (!node || !node.getAttribute) continue;
        var id = node.getAttribute('id') || '';
        if (id.indexOf(substr) !== -1) return true;
      }
      return false;
    }
    function pathHasHrefContaining(path, substr) {
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (!node || node.tagName !== 'A') continue;
        var href = (node.getAttribute && node.getAttribute('href')) || '';
        if (href.indexOf(substr) !== -1) return true;
      }
      return false;
    }
    /** Any node in path has textContent (trimmed, lowercase) equal to or containing this word – for Shadow DOM tab buttons */
    function pathHasNodeWithText(path, word) {
      var w = (word || '').toLowerCase().trim();
      if (!w) return false;
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (!node || node.nodeType !== 1) continue;
        var t = (getText(node) || '').toLowerCase().trim();
        if (t === w || t.indexOf(w) === 0) return true;
      }
      return false;
    }
    var isInstagramTabOrContent = pathHasNodeWithText(path, 'Instagram') ||
      (btn && (getText(btn).trim().toLowerCase() === 'instagram' || getTextUp(btn, 2).toLowerCase().indexOf('instagram') !== -1)) ||
      /instagram\s*reels?/i.test(pathText) ||
      /load\s*more\s*videos?/i.test(pathText) ||
      /loading\s*videos?/i.test(pathText) ||
      /no\s*videos?\s*available/i.test(pathText) ||
      pathHasIdContaining(path, 'instagram') ||
      pathHasHrefContaining(path, 'instagram.com') ||
      (typeof window !== 'undefined' && window.womReviewTab === 'instagram');
    if (isInstagramTabOrContent) {
      capture('wom_instagram_reviews_clicked', {});
      return;
    }

    // ---- Brand reviews (fallback: button/link text "Brand Reviews") ----
    if (/brand\s*reviews?/i.test(text) || /brand\s*reviews?/i.test(pathText) || (combinedText.indexOf('brand') !== -1 && combinedText.indexOf('review') !== -1)) {
      capture('wom_brand_reviews_clicked', {});
      return;
    }

    // ---- WOM Pagination: prev/next arrows and page number buttons ----
    function pathHasSvgPathD(path, leftRight) {
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (!n || n.nodeType !== 1) continue;
        if (n.tagName === 'path' && n.getAttribute) {
          var d = (n.getAttribute('d') || '').replace(/\s+/g, ' ');
          if (leftRight === 'prev' && (d.indexOf('M15 18') !== -1 || d.indexOf('15 18') !== -1)) return true;
          if (leftRight === 'next' && (d.indexOf('M9 18') !== -1 || d.indexOf('9 18') !== -1) && d.indexOf('15') === -1) return true;
        }
        var paths = n.querySelectorAll && n.querySelectorAll('path[d]');
        if (paths) for (var j = 0; j < paths.length; j++) {
          var pd = (paths[j].getAttribute('d') || '').replace(/\s+/g, ' ');
          if (leftRight === 'prev' && (pd.indexOf('M15 18') !== -1 || pd.indexOf('15 18') !== -1)) return true;
          if (leftRight === 'next' && pd.indexOf('M9 18') !== -1 && pd.indexOf('15') === -1) return true;
        }
      }
      return false;
    }
    var btnContent = btn ? (getText(btn) || (btn.innerHTML && btn.innerHTML.replace(/<[^>]+>/g, '').trim()) || '').trim() : '';
    var isPrevBtn = label === 'Previous page' || label === 'Previous Page' || btnContent === '\u2039' || btnContent === '\u00AB' || btnContent === '\u2190' || (btn && btn.innerHTML && btn.innerHTML.indexOf('\u2039') !== -1) || btnContent === '<' || pathHasSvgPathD(path, 'prev');
    var isNextBtn = label === 'Next page' || label === 'Next Page' || btnContent === '\u203A' || btnContent === '\u00BB' || btnContent === '\u2192' || (btn && btn.innerHTML && btn.innerHTML.indexOf('\u203A') !== -1) || btnContent === '>' || pathHasSvgPathD(path, 'next');
    if (btn && (isPrevBtn || isNextBtn) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', {
        type: 'arrow',
        direction: isPrevBtn ? 'prev' : 'next',
        linkText: label || (isPrevBtn ? 'Previous page' : 'Next page')
      });
      return;
    }

    var pageNum = btn ? getText(btn).trim() : (getText(target) || (clickEl && getText(clickEl)) || '').trim();
    if (btn && /^\d+$/.test(pageNum) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', {
        type: 'page',
        page: parseInt(pageNum, 10),
        linkText: pageNum
      });
      return;
    }
    var digitText = (clickEl && getText(clickEl)) || (target && getText(target)) || '';
    if (/^\d+$/.test(digitText.trim()) && !pathHas(path, 'data-wom-rating-breakdown-container')) {
      capture('wom_pagination_clicked', {
        type: 'page',
        page: parseInt(digitText.trim(), 10),
        linkText: digitText.trim()
      });
      return;
    }

    // Write a review
    if (/write\s*(a\s*)?review/i.test(text) || /write\s*(a\s*)?review/i.test(pathText) || (combinedText.indexOf('write') !== -1 && combinedText.indexOf('review') !== -1)) {
      capture('wom_write_review_clicked', {});
      return;
    }

    // ---- Customer review image clicked (images clicked) ----
    if (pathHas(path, 'data-wom-review-card')) {
      if (target.tagName === 'IMG') {
        capture('wom_review_image_clicked', {});
        return;
      }
      for (var pi = 0; pi < path.length; pi++) {
        var n = path[pi];
        if (n && n.className && typeof n.className === 'string' && n.className.indexOf('wom-review-images-gallery') !== -1) {
          capture('wom_review_image_clicked', {});
          return;
        }
      }
    }

    // View all images: only when click is inside customer photos gallery AND text is "view all images/photos"
    var isInImageGallery = pathHas(path, 'data-wom-image-gallery') || pathHasClass(path, 'wom-image-gallery');
    var viewAllImagesText = /view\s*all\s*(images?|photos?)/i.test(text) || /view\s*all\s*(images?|photos?)/i.test(pathText);
    if (isInImageGallery && viewAllImagesText) {
      capture('wom_view_all_images_clicked', {});
      return;
    }

    // Pagination: Load more / link with page in URL
    if (btn || (clickEl && clickEl.tagName === 'A')) {
      var href = (target.getAttribute && target.getAttribute('href')) || (btn && btn.getAttribute && btn.getAttribute('href'));
      var paginationText = getText(btn || clickEl || target);
      var paginationLower = paginationText.toLowerCase();
      if (/next|previous|prev/i.test(paginationText) || (href && /page=|\/page\//.test(href)) ||
          paginationLower.indexOf('load more') !== -1 || paginationLower === 'load more') {
        capture('wom_pagination_clicked', {
          type: 'link',
          linkText: paginationText,
          pageUrl: href || undefined
        });
        return;
      }
    }

    // Star filters: 5, 4, 3, 2, 1 or All
    var filterValue = null;
    if (pathHas(path, 'data-wom-rating-breakdown-container') || pathHas(path, 'data-wom-reviews-list-container') || pathHas(path, 'data-wom-component', 'rating-breakdown')) {
      var filterText = text.replace(/\s+/g, ' ').trim();
      if (/^all\s*(reviews?)?$/i.test(filterText)) filterValue = 'all';
      else if (/^5\s*(\*|star)/i.test(filterText) || filterText === '5') filterValue = '5';
      else if (/^4\s*(\*|star)/i.test(filterText) || filterText === '4') filterValue = '4';
      else if (/^3\s*(\*|star)/i.test(filterText) || filterText === '3') filterValue = '3';
      else if (/^2\s*(\*|star)/i.test(filterText) || filterText === '2') filterValue = '2';
      else if (/^1\s*(\*|star)/i.test(filterText) || filterText === '1') filterValue = '1';
      if (!filterValue && /^\d$/.test(filterText)) filterValue = filterText;
      if (!filterValue && pathText.match(/\b(5|4|3|2|1)\s*star/i)) filterValue = pathText.match(/\b(5|4|3|2|1)\s*star/i)[1];
    }
    if (target.getAttribute && target.getAttribute('data-stars')) {
      filterValue = target.getAttribute('data-stars');
    }
    if (filterValue) {
      capture('wom_filter_changed', { filterValue: String(filterValue) });
    }
  }, true);
})();
